import * as Yup from 'yup';
import checkoutFormModel from './formModel';
import moment from "moment";

const {
    formField: {
        afinidad,
        codigosLocalidad,
        coberturasAdicionales: {
            sumaAsegurada,
            numeroCobertura,
            selectedCobertura
        },
        fechaCotizacion
    }
} = checkoutFormModel;


export default [
    Yup.object().shape({
        [afinidad.name]: Yup.string().required(`${afinidad.requiredErrorMsg}`),
        [codigosLocalidad.name]: Yup.string().required(`${codigosLocalidad.requiredErrorMsg}`),
        coberturasAdicionales: Yup.array().of(
            Yup.object().shape(
                {
                    [sumaAsegurada.name]: Yup.number().required(),
                    [numeroCobertura.name]: Yup.string().required(),
                    [selectedCobertura.name]: Yup.boolean().required(),
                }
            )
        ).test('product-selection', 'Debe seleccionar al menos un producto', coberturas => {
            let coberturasArray = []
            for (let cob of coberturas){
                coberturasArray.push(cob.selectedCobertura)
            }
            return coberturasArray.some(cobertura => cobertura)
        }),
        [fechaCotizacion.name]: Yup.date()
            .required(`${fechaCotizacion.requiredErrorMsg}`)
            .min(moment().format('YYYY-MM-DD'), "La fecha no puede ser anterior al dia de hoy")
            .max(moment().add(45, "days").format('YYYY-MM-DD'), "La fecha no puede superar los 45 dias"),
    }),
];
